export const printerTranslations = {
    en: {
        // Printer Management
        printerManagement: 'Printer Management',
        addPrinter: 'Add Printer',
        editPrinter: 'Edit Printer',
        printerName: 'Printer Name',
        printerType: 'Printer Type',
        printerLocation: 'Printer Location',
        printerStatus: 'Printer Status',
        ipAddress: 'IP Address',
        port: 'Port',
        paperSize: 'Paper Size',
        testPrint: 'Test Print',
        printerSettings: 'Printer Settings',
        defaultPrinter: 'Default Printer',
        receiptPrinter: 'Receipt Printer',
        kitchenPrinter: 'Kitchen Printer',
        barPrinter: 'Bar Printer',
        printerConnected: 'Printer Connected',
        printerDisconnected: 'Printer Disconnected',
        printerError: 'Printer Error',
        paperWidth: 'Paper Width',
        characterLimit: 'Character Limit',
        printDensity: 'Print Density',
        printSpeed: 'Print Speed',
        autocut: 'Auto Cut',
        cashdrawer: 'Cash Drawer',
        buzzer: 'Buzzer',
        testPrintSuccess: 'Test print sent successfully',
        testPrintError: 'Error sending test print'
    },
    ar: {
        // Printer Management
        printerManagement: 'إدارة الطابعات',
        addPrinter: 'إضافة طابعة',
        editPrinter: 'تعديل الطابعة',
        printerName: 'اسم الطابعة',
        printerType: 'نوع الطابعة',
        printerLocation: 'موقع الطابعة',
        printerStatus: 'حالة الطابعة',
        ipAddress: 'عنوان IP',
        port: 'المنفذ',
        paperSize: 'حجم الورق',
        testPrint: 'اختبار الطباعة',
        printerSettings: 'إعدادات الطابعة',
        defaultPrinter: 'الطابعة الافتراضية',
        receiptPrinter: 'طابعة الإيصالات',
        kitchenPrinter: 'طابعة المطبخ',
        barPrinter: 'طابعة البار',
        printerConnected: 'الطابعة متصلة',
        printerDisconnected: 'الطابعة غير متصلة',
        printerError: 'خطأ في الطابعة',
        paperWidth: 'عرض الورق',
        characterLimit: 'حد الأحرف',
        printDensity: 'كثافة الطباعة',
        printSpeed: 'سرعة الطباعة',
        autocut: 'قص تلقائي',
        cashdrawer: 'درج النقد',
        buzzer: 'جرس التنبيه',
        testPrintSuccess: 'تم إرسال اختبار الطباعة بنجاح',
        testPrintError: 'خطأ في إرسال اختبار الطباعة'
    }
};
